import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './richTextEditor.css';

const RichTextEditor = ({
  editorState, // now HTML string
  handleEditorStateChange,
  errorMessage,
}) => {

  const isDarkTheme = localStorage.getItem('theme') === 'dark';

  const text = editorState && editorState.toString() || '';
  return (
    <>
      <div
        className={
          isDarkTheme ? 'dark-editor-wrapper' : 'editor-wrapper'
        }
      >
        <ReactQuill
          value={text}
          onChange={handleEditorStateChange}
          className={isDarkTheme ? 'dark-editor' : 'editor'}
          theme="snow"
          modules={{
            toolbar: [
              // ['bold', 'italic', 'underline'],
              ['link'],
              // ['clean']
            ]
          }}

        />
      </div>

      {errorMessage && <span className='error-message'>{errorMessage}</span>}
    </>
  );
};

export default RichTextEditor;
